import { Box } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import MaterializedProcessesTable from 'modules/processes/components/MaterializedProcessesTable'
import { useProcessContext } from 'modules/processes/pages/Process/ProcessRootPage'
import Header from 'modules/processes/pages/Process/components/Header'

const EmployeeProcessPage = () => {
  const { process } = useProcessContext()

  useEffect(() => {
    track(trackingEvents.processes.processOverviewOpened)
  }, [])

  return (
    <>
      <Header process={process} />
      <Box paddingY="s24" gap="s8">
        <MaterializedProcessesTable process={process} />
      </Box>
    </>
  )
}

export default EmployeeProcessPage
